import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const ProductIntro = ({
  title,
  description,
  features,
  brochure,
  images,
  slug
}) => {

  /*
    images format:

    [
      {
        small: smallImg1,
        big: bigImg1,
      },
      {
        small: smallImg2,
        big: bigImg2,
      },
    ]
  */

const [activeIndex, setActiveIndex] = useState(0);

useEffect(() => {

  const interval = setInterval(() => {

    setActiveIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );

  }, 5000);

  return () => clearInterval(interval);

}, [images.length]);

  /* NEXT */

  const handleNext = () => {
  setActiveIndex((prev) =>
    prev === images.length - 1 ? 0 : prev + 1
  );
};

const handlePrev = () => {
  setActiveIndex((prev) =>
    prev === 0 ? images.length - 1 : prev - 1
  );
};
  return (
    <>
      <section className="product-intro-section">

        <div className="container">

          <div className="product-intro-grid">

            {/* LEFT */}

            <div className="product-intro-gallery">

              {/* BIG IMAGE */}

              <div className="product-intro-main-image-wrapper">

               <AnimatePresence mode="wait">

  <motion.img
    key={images[activeIndex]?.big}
    src={images[activeIndex]?.big}
   alt={
  activeIndex === 0
    ? `${title} | Gurukrupa Wood Pvt. Ltd.`
    : `${title} ${activeIndex} | Gurukrupa Wood Pvt. Ltd.`
}
    className="product-intro-main-image"

    initial={{
      opacity: 0,
      scale: 0.96,
    }}

    animate={{
      opacity: 1,
      scale: 1,
    }}

    exit={{
      opacity: 0,
    }}

    transition={{
      duration: 0.4,
    }}
  />

</AnimatePresence>

              </div>

              {/* THUMBNAILS */}

              <div className="product-intro-thumb-row">

                {/* LEFT ARROW */}

                <button
  type="button"
  className="product-intro-arrow"
  onClick={handlePrev}
>
                  <FaChevronLeft />
                </button>

                {/* THUMB GRID */}

               <div className="product-intro-thumb-grid">

  {images.map((img, i) => {

    if (i === activeIndex) return null;

    return (

      <motion.div
        key={i}
        className="product-intro-thumb-card"
        whileHover={{
          y: -4,
        }}
        onClick={() => setActiveIndex(i)}
      >

        <img
          src={img.small}
         alt={
  i === 0
    ? `${title} | Gurukrupa Wood Pvt. Ltd.`
    : `${title} ${i} | Gurukrupa Wood Pvt. Ltd.`
}
        />

      </motion.div>

    );
  })}

</div>

                {/* RIGHT ARROW */}

                <button
                  className="product-intro-arrow"
                  onClick={handleNext}
                >
                  <FaChevronRight />
                </button>

              </div>

            </div>

            {/* RIGHT */}

            <div className="product-intro-content">

              <motion.h2
                className="section-heading"
                initial={{
                  opacity: 0,
                  y: 30,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.7,
                }}
                viewport={{
                  once: true,
                }}
              >
                {title}
              </motion.h2>

              <motion.p
                className="section-text"
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.7,
                  delay: 0.1,
                }}
                viewport={{
                  once: true,
                }}
              >
                {description}
              </motion.p>

              {/* FEATURES */}

              <div className="product-intro-features-grid">

                {features.map((item, i) => (

                  <motion.div
                    className="product-intro-feature-card"
                    key={i}
                    initial={{
                      opacity: 0,
                      y: 20,
                    }}
                    whileInView={{
                      opacity: 1,
                      y: 0,
                    }}
                    transition={{
                      duration: 0.5,
                      delay: i * 0.08,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <div className="product-intro-feature-icon">

                      <img
                        src={item.icon}
                        alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
                      />

                    </div>

                    <h4 className="card-heading">
                      {item.title}
                    </h4>

                  </motion.div>

                ))}

              </div>

              {/* BUTTONS */}

              <div className="product-intro-btn-row">

                <a
                  href={ slug || "/products/customised-packaging" }
                  className="green-btn"
                >
                  Get a Quote
                </a>

                <a
                  href={brochure}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="product-intro-outline-btn"
                >
                  Download Brochure
                </a>

              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default ProductIntro;